import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {MaterialPlanningListAbstractService} from '../../../material/planning/material-planning-list.abstract-service';
import {MaterialSelectLister} from '../../../material/planning/material-planning.model';
import {environment} from '../../../../../environments/environment';
import {EnvisiaLocation} from '../../../../common/location/envisia-location';
import {HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class BusinessOrderMaterialPlanningListService extends MaterialPlanningListAbstractService {
  constructor(private http: HttpClient) {
    super();
  }

  list(groupId: number, query?: any): Observable<MaterialSelectLister> {
    return this.http.get<MaterialSelectLister>(
      `${environment.apiv4uri}material/planning/business/order/${groupId}`,
      {params: EnvisiaLocation.httpParams(query)}
    );
  }
}
